<template>
    <input hidden ref="file" @change="onChange" type="file" :accept="$attrs.accept">

    <slot :props="{to_upload, uploading, errors}" :methods="{open,remove,reset}">
    </slot>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import filesManager from "../api/File";

@Options({
    name: 'SingleFileUpload',
    components: {NextButton},
    inheritAttrs: false,
    props: {
        file: {
            required: false,
            type: Object,
            default: () => null
        },
    }
})
export default class SingleFileUpload extends Vue {

    private to_upload: File[] = []
    private uploaded_files!: any[]
    private uploading = false
    private errors: any = {}

    send() {
        this.uploading = true
        const data = new FormData()

        this.to_upload.forEach((f) => {
            data.append('assets[]', f)
        })
        return filesManager.filesCreate(data).then((res) => {
            this.to_upload.splice(0)
            this.$emit('update:file', res.data[0])
            this.errors = {}
            return res
        }).catch(res => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
        }).finally(() => {
            this.uploading = false
        })
    }

    onChange(ev: Event) {
        if (this.$attrs.readonly) return;
        const files = (ev.target as HTMLInputElement).files || (ev as DragEvent).dataTransfer?.files;
        if (!files?.length) return;

        this.to_upload.splice(0, this.to_upload.length, files[0])

        this.send();
    }

    open() {
        if (this.$attrs.readonly) return;
        (this.$refs.file as HTMLBaseElement).click()
    }
    reset() {
        (this.$refs.file as HTMLInputElement).value = ''
        this.to_upload.splice(0)
        this.errors = {}
    }

    remove(list:any[], idx: number) {
        list.splice(idx, 1)
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
